import pdfmake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { cloneDeep } from 'lodash';
import pdfImage from '../json/pdfImages.json';

export default class PDFMakerGis {
  constructor() {
    pdfmake.vfs = pdfFonts.pdfMake.vfs;
    pdfmake.fonts = {
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf',
      },
    };

    this.pdfData = {
      footer(currentPage, pageCount) {
        return {
          columns: [
            { width: '*', text: '' },
            {
              stack: [
                {
                  canvas: [
                    {
                      type: 'rect',
                      x: 0,
                      y: 0,
                      w: 20,
                      h: 20,
                      r: 4,
                      color: '#0172C1',
                    },
                  ],
                },
                {
                  text: currentPage.toString(),
                  fontSize: 10,
                  bold: true,
                  color: '#FFFFFF',
                  relativePosition: { x: 0, y: -16 },
                  alignment: 'center',
                  width: 20,
                },
              ],
              width: 20,
            },
          ],
          margin: [0, 20, 20, 0],
        };
      },
      header(currentPage, pageCount, pageSize) {
        return [
          {
            margin: [20, 10, 20, 0],
            columns: [
              {
                image: pdfImage.timac_image,
                width: 200,
              },
              {
                margin: [100, 0, 0, 0],
                image: pdfImage.contact_image,
                width: 160,
              },
              {
                margin: [110, 10, 0, 0],
                image: pdfImage.roullier_image,
                width: 30,
              },
              {
                margin: [125, 10, 0, 0],
                image: pdfImage.iso_image,
                width: 30,
              },
            ],
          },
        ];
      },
      content: [],
      pageSize: 'A4',
      pageMargins: [20, 80, 20, 60],
      styles: {
        blueContainerTitle: {
          margin: [4, 4, 4, 4],
          fontSize: 12,
          color: '#0573B2',
          bold: true,
        },
        h1: { fontSize: 18, bold: true, margin: [0, 14, 0, 8] },
        h2: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 8],
          color: '#444',
        },
        h3: {
          fontSize: 14,
          bold: true,
          margin: [0, 22, 0, 8],
          color: '#666',
        },
        tableHeaderCell: {
          margin: [1, 1, 1, 1],
          fontSize: 8,
          fillColor: '#EBEBEB',
          color: '#545454',
          bold: false,
        },
        tableNormalCell: {
          margin: [2, 2, 2, 2],
          fontSize: 8,
          fillColor: '#fff',
          color: '#000000',
          bold: false,
        },
        blueContainer: {
          margin: [0, 12, 0, 0],
        },
        reportTitleStyle: {
          margin: [0, 8, 0, 0],
          fontSize: 16,
          color: '#0272BA',
          bold: true,
        },
        noBordersCell: {
          margin: [8, 2, 8, 2],
          fontSize: 8,
          bold: false,
        },
        noBordersCellSmall: {
          margin: [1, 1, 1, 1],
          fontSize: 8,
          bold: false,
        },
        noBordersCellSignature: {
          margin: [8, 2, 8, 2],
          fontSize: 8,
          bold: false,
        },
        bigger: {
          fontSize: 15,
          italics: true,
        },
        commentStyleTitle: {
          fontSize: 8,
          italics: false,
          bold: false,
        },
        commentStyle: {
          fontSize: 8,
          italics: false,
        },
        normalStyle: {
          fontSize: 8,
        },
        normalStyle2: {
          fontSize: 12,
        },
        observationsTitle: {
          fontSize: 8,
          margin: [0, 8, 0, 4],
        },
        observationsList: {
          fontSize: 8,
          margin: [10, 0, 0, 0],
        },
        legalText: {
          margin: [8, 24, 8, 8],
          fontSize: 8,
          bold: false,
          color: '#000000',
        },
        footer: {
          margin: [10, 10, 10, 10],
        },
      },
    };

    // Layout sin bordes para tablas específicas
    this.noBordersLayout = {
      hLineWidth: function (i, node) {
        return 0;
      },
      vLineWidth: function (i, node) {
        return 0;
      },
      paddingLeft: function (i, node) {
        return 2;
      },
      paddingRight: function (i, node) {
        return 2;
      },
      paddingTop: function (i, node) {
        return 2;
      },
      paddingBottom: function (i, node) {
        return 2;
      },
    };
  }

  getBlueContainer(title, breakTabla = true) {
    let tableOptions = {};

    if (breakTabla) {
      return {
        style: 'blueContainer',
        stack: [
          {
            table: {
              widths: ['*'],
              body: [[{ text: title, style: 'blueContainerTitle' }]],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 1 ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
              hLineColor: function (i, node) {
                return i === 1 ? '#0573B2' : '#000';
              },
              paddingLeft: function (i, node) {
                return 0;
              },
              paddingRight: function (i, node) {
                return 0;
              },
              paddingTop: function (i, node) {
                return 0;
              },
              paddingBottom: function (i, node) {
                return 0;
              },
            },
          },
          {
            table: {
              widths: ['*'],
              body: [[]],
            },
            layout: 'noBorders',
          },
        ],
      };
    }

    return {
      style: 'blueContainer',
      table: {
        ...tableOptions,
        headerRows: 1,
        widths: ['*'],
        body: [[{ text: title, style: 'blueContainerTitle' }], []],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 1 ? 1 : 0;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === 1 ? '#0573B2' : '#000';
        },
        paddingLeft: function (i, node) {
          return i === 0 ? 0 : 0;
        },
        paddingRight: function (i, node) {
          return i === 0 ? 0 : 0;
        },
        paddingTop: function (i, node) {
          return i === 1 ? 2 : 0;
        },
        paddingBottom: function (i, node) {
          return i === 0 ? 0 : 8;
        },
      },
    };
  }

  insertTableWithoutBorders(data) {
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(data[0])) {
      this.pdfData.content.push({
        table: {
          widths: [],
          body: [[]],
        },
      });
      return;
    }
    const blueContainer = this.getBlueContainer(
      'Datos de la explotación',
      false,
    );

    const table = {
      widths: Array(data[0].length).fill(
        `${(100 / data[0].length).toFixed(2)}%`,
      ),
      body: [],
    };

    data.forEach((row) => {
      const headers = row.map((cell) => {
        if (cell.title.length === 0 && cell.text.length === 0) {
          return {
            style: 'noBordersCell',
            text: '',
          };
        }

        return {
          style: 'noBordersCell',
          text: [
            {
              text: `${cell.title}: `,
              fontSize: 8,
              bold: false,
              color: '#545454',
            },
            { text: cell.text, fontSize: 8, bold: false, color: '#000000' },
          ],
        };
      });
      table.body.push(headers);
    });

    blueContainer.table.body[1].push({ table, layout: this.noBordersLayout });
    blueContainer.table.body.push([{ text: '' }]);
    blueContainer.layout.hLineWidth = function (i) {
      return i === 1 || i === 2 ? 1 : 0;
    };
    blueContainer.layout.hLineColor = function (i) {
      return i === 1 || i === 2 ? '#0573B2' : '#000';
    };

    this.pdfData.content.push(blueContainer);
  }

  async inserTableSatelliteImages(data) {
    const table = {
      widths: Array(data[0].length).fill(
        `${(100 / data[0].length).toFixed(2)}%`,
      ),
      body: [],
    };

    for (const row of data) {
      const rows = await Promise.all(row.map(async (cell) => {
        if (!Array.isArray(cell)) {
          return [
            {
              alignment: 'center',
              image: cell.image,
              width: 180,
            },
            {
              alignment: 'center',
              image: cell.stack,
              height: 75,
              width: 200,
            },
          ];
        }

        return [];
      }));

      table.body.push(rows);
    }

    this.pdfData.content.push({ table, layout: 'noBorders' });
  }

  async insertChart(chart) {
    const pdfChart = {
      widths: ['*'],
      body: [],
    };

    // Calcular ancho disponible en A4 teniendo en cuenta los márgenes
    const PAGE_WIDTHS = {
      A4: 595.28,
    };
    const pageSize = this.pdfData.pageSize || 'A4';
    const pageWidthPts = PAGE_WIDTHS[pageSize] || 595.28;
    const margins = this.pdfData.pageMargins || [20, 80, 20, 60];
    const availableWidth = Math.max(0, Math.floor(pageWidthPts - margins[0] - margins[2]));

    // Usar el ancho disponible y permitir un poco más de altura para mejor legibilidad
    const imageWidth = availableWidth; // ocupar todo el espacio horizontal utilizable
    const imageHeight = Math.round(availableWidth * 0.45); // altura proporcional (aprox 45%)

    pdfChart.body.push([
      {
        alignment: 'center',
        image: chart.image,
        width: imageWidth,
        height: imageHeight,
      },
    ]);

    this.pdfData.content.push({
      table: pdfChart,
      layout: 'noBorders',
      margin: [0, 15, 0, 15],
    });
  }

  insertReportTitle(text) {
    this.pdfData.content.push({ text, style: 'reportTitleStyle' });
  }

  insertTableBottomSignature(data) {
    const blueContainer = this.getBlueContainer(
      'Información',
      false,
    );

    const table = {
      widths: [],
      body: [],
    };

    // Validar que data existe y tiene elementos
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(data[0])) {
      blueContainer.table.body[1].push({ table, layout: this.noBordersLayout });
      this.pdfData.content.push(blueContainer);
      return;
    }

    const celldimension = (100 / data[0].length).toFixed(2);
    data[0].forEach((_) => {
      table.widths.push(`${celldimension}%`);
    });

    data.forEach((row) => {
      const headers = row.map((cell) => {
        // Validar que cell es un array con al menos 2 elementos
        if (!Array.isArray(cell) || cell.length < 2) {
          return {
            style: 'noBordersCellSignature',
            text: '',
          };
        }
        return {
          style: 'noBordersCellSignature',
          text: [
            {
              text: `${cell[0]}: `,
              fontSize: 8,
              bold: false,
              color: '#545454',
            },
            { text: cell[1], fontSize: 8, bold: false, color: '#000000' },
          ],
        };
      });
      table.body.push(headers);
    });

    blueContainer.table.body[1].push({ table, layout: this.noBordersLayout });
    blueContainer.unbreakable = true;

    this.pdfData.content.push(blueContainer);
  }
  // Funcion para insertar comentarios en el pdf
  insertTableBottomComments(data) {
    const blueContainer = this.getBlueContainer('Comentarios', false);
  
    const table = {
      widths: [],
      body: [],
    };
  
    const celldimension = (100 / data[0].length).toFixed(2);
    data[0].forEach((_) => {
      table.widths.push(`${celldimension}%`);
    });
  
    data.forEach((row) => {
      const headers = row.map((cell) => ({
        style: 'noBordersCellSmall',
        text: { text: cell[0], fontSize: 8, bold: false, color: '#000000' },
      }));
      table.body.push(headers);
    });
  
    blueContainer.table.body[1].push({ table, layout: this.noBordersLayout, alignment: 'left' });
  
    this.pdfData.content.push(blueContainer);
  }

  // Función para insertar las observaciones
  insertObservations(data) {
    const blueContainer = this.getBlueContainer('Observaciones', false);

    const table = {
      widths: ['100%'],
      body: [],
    };

    data.forEach((row) => {
      table.body.push([{ text: row.title, style: 'observationsTitle' }]);

      const comments = [];

      row.comment.forEach((comment) => {
        comments.push({ text: `${comment[0]}: `, style: 'commentStyleTitle' });
        comments.push({ text: `${comment[1]}. `, style: 'normalStyle' });
      });

      table.body.push([
        {
          style: 'observationsList',
          ul: [
            { text: `Fecha: ${row.date}`, style: 'normalStyle' },
            {
              text: comments,
            },
          ],
        },
      ]);

      for (const multimediaItem of row.multimedia) {
        
        table.body.push([
          {
            image: multimediaItem.base64,
            width: 250,
            alignment: 'center',
            margin: [0, 0, 0, 15],
          },
        ]);
      }
    });

    blueContainer.table.body[1].push({ table, layout: this.noBordersLayout });

    this.pdfData.content.push(blueContainer);
  }

  async getPdfAsBuffer() {
    const pdfDocGenerator = pdfmake.createPdf(cloneDeep(this.pdfData));
    return new Promise((resolve) => {
      pdfDocGenerator.getBuffer((buffer) => {
        resolve(buffer);
      });
    });
  }

  async buildAndDownload(filename) {
    return new Promise((resolve) => {
      pdfmake.createPdf(this.pdfData).download(filename, () => {
        resolve();
      });
    });
  }

  buildForMobile() {
    const pdfBuild = pdfmake.createPdf(cloneDeep(this.pdfData));
    return pdfBuild;
  }
}
